// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let ReactAriaComponents = require("react-aria-components");

function MenuV5$MenuItem(props) {
  let children = props.children;
  return JsxRuntime.jsx(ReactAriaComponents.MenuItem, {
    children: param => JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        children,
        param.hasSubmenu ? JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "arrow-right",
              size: 14
            }),
            "aria-hidden": true,
            className: "ml-auto text-gray-600 group-data-[focused]:text-white transition-colors"
          }) : null
      ]
    }),
    textValue: props.textValue,
    className: TailwindMerge.twMerge([
      "group w-full relative flex cursor-default select-none items-center gap-2 rounded-md px-3 py-2 outline-none transition-colors text-gray-800 text-base",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "data-[focused]:bg-tan-blue-500 cursor-pointer data-[focused]:outline-none data-[focused]:text-white",
      "data-[selection-mode]:pl-8",
      Stdlib_Option.getOr(props.className, "")
    ]),
    href: props.href,
    isDisabled: props.isDisabled,
    onAction: props.onAction
  });
}

let MenuItem = {
  make: MenuV5$MenuItem
};

function MenuV5$Popover(props) {
  return JsxRuntime.jsx(ReactAriaComponents.Popover, {
    children: props.children,
    className: TailwindMerge.twMerge([
      "w-52 group rounded-md border bg-white p-1 shadow-md outline-none",
      Stdlib_Option.getOr(props.className, "")
    ]),
    placement: props.placement
  });
}

let Popover = {
  make: MenuV5$Popover
};

function MenuV5$Submenu(props) {
  return JsxRuntime.jsxs(ReactAriaComponents.SubmenuTrigger, {
    children: [
      JsxRuntime.jsx(MenuV5$MenuItem, {
        isDisabled: props.isDisabled,
        children: props.name
      }),
      JsxRuntime.jsx(MenuV5$Popover, {
        children: JsxRuntime.jsx(ReactAriaComponents.Menu, {
          children: props.children
        }),
        className: "w-auto"
      })
    ]
  });
}

let Submenu = {
  make: MenuV5$Submenu
};

function MenuV5$Menu(props) {
  return JsxRuntime.jsxs(ReactAriaComponents.MenuTrigger, {
    children: [
      props.button,
      JsxRuntime.jsx(MenuV5$Popover, {
        children: JsxRuntime.jsx(ReactAriaComponents.Menu, {
          children: props.children,
          className: "max-h-[inherit] overflow-auto rounded-md p-1 outline-0"
        }),
        placement: props.placement
      })
    ]
  });
}

let Menu = {
  make: MenuV5$Menu
};

function MenuV5$UnavailableItem(props) {
  let unavailableDescription = props.unavailableDescription;
  let name = props.name;
  return JsxRuntime.jsxs(ReactAriaComponents.SubmenuTrigger, {
    children: [
      JsxRuntime.jsx(ReactAriaComponents.MenuItem, {
        children: param => JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            name,
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "attention-alt",
                size: 14
              }),
              "aria-hidden": true,
              className: "ml-auto text-gray-600 group-data-[focused]:text-white transition-colors"
            })
          ]
        }),
        className: TailwindMerge.twMerge([
          "group w-full relative flex cursor-default select-none items-center gap-2 rounded-md px-3 py-2 outline-none transition-colors text-gray-800 text-base",
          "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
          "data-[focused]:bg-tan-blue-500 cursor-pointer data-[focused]:outline-none data-[focused]:text-white",
          "data-[selection-mode]:pl-8",
          Stdlib_Option.getOr(props.className, "")
        ])
      }),
      JsxRuntime.jsxs(MenuV5$Popover, {
        children: [
          JsxRuntime.jsx("div", {
            children: props.unavailableReason,
            className: "text-base font-semibold text-gray-700"
          }),
          unavailableDescription !== undefined ? JsxRuntime.jsx("div", {
              children: unavailableDescription
            }) : null
        ],
        className: "w-auto p-5 flex flex-col gap-4"
      })
    ]
  });
}

let UnavailableItem = {
  make: MenuV5$UnavailableItem
};

let LinkButton;

let Button;

let SecondaryButton;

let DarkSecondaryButton;

let PrimaryButton;

let SubmenuTrigger;

let MenuTrigger;

exports.LinkButton = LinkButton;
exports.Button = Button;
exports.SecondaryButton = SecondaryButton;
exports.DarkSecondaryButton = DarkSecondaryButton;
exports.PrimaryButton = PrimaryButton;
exports.MenuItem = MenuItem;
exports.SubmenuTrigger = SubmenuTrigger;
exports.MenuTrigger = MenuTrigger;
exports.Popover = Popover;
exports.Submenu = Submenu;
exports.Menu = Menu;
exports.UnavailableItem = UnavailableItem;
/* IconV5 Not a pure module */
